module.exports = __webpack_public_path__ + "static/media/lipstick-liq.1d726f8f.jpg";